module.exports = __webpack_public_path__ + "static/media/ezra-retro.148d34e2.png";